var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46191 21.6641C1.8291 21.6641 0.980469 20.7939 0.980469 19.0322V11.416C0.980469 9.86914 1.65723 8.99902 2.94629 8.82715V6.28125C2.94629 2.31738 5.56738 0.265625 8.5 0.265625C11.4326 0.265625 14.0537 2.31738 14.0537 6.28125V8.83789C15.3428 9.00977 16.0088 9.86914 16.0088 11.416V19.0322C16.0088 20.7939 15.1602 21.6641 13.5273 21.6641H3.46191ZM4.95508 6.08789V8.79492H12.0449V6.08789C12.0449 3.56348 10.4121 2.18848 8.5 2.18848C6.57715 2.18848 4.95508 3.56348 4.95508 6.08789Z",
    fill: "#E5E5EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.efca6eb38a422273905ca0d8904fcab1.svg";
export { ForwardRef as ReactComponent };